import React, { useState, useRef } from "react";
import { GetUser, UpdateUser, uploadUserFile } from "../../../../Redux/Slices/User";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { TfiDownload } from "react-icons/tfi";
import { TbReplaceFilled } from "react-icons/tb";
import { BsFilePdf } from "react-icons/bs";
import { FaRegEye, FaCloudUploadAlt } from "react-icons/fa";

const Resume = ({ userData }) => {
  const id = localStorage.getItem("id");
  const [resume, setResume] = useState(null);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const filePath = userData?.resume?.split("/")?.slice(-1)?.[0];
  const resumeUrl = process.env.REACT_APP_AZURE_STORAGE_URL;

  const handleFileChange = (e) => {
    const selected = e.target.files?.[0] || null;
    if (selected && selected.type !== "application/pdf") {
      toast.error("Please upload a PDF file");
      return;
    }
    if (selected && selected.size > 5 * 1024 * 1024) {
      toast.error("Resume must be smaller than 5MB");
      return;
    }
    setResume(selected);
  };

  const openFileInput = () => {
    fileInputRef.current?.click();
  };

  const handleResumeUpload = async () => {
    if (!resume) {
      toast.error("Add a resume file before uploading");
      return;
    }
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("resume", resume);
      await uploadUserFile(id, formData);
      dispatch(GetUser(id));
      setResume(null);
    } catch (error) {
      console.error("Error uploading resume:", error);
      toast.error("Error uploading resume. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleView = () => {
    if (!userData?.resume) return;
    window.open(resumeUrl + userData.resume, "_blank");
  };

  const handleDownload = () => {
    if (!userData?.resume) return;
    window.open(resumeUrl + userData.resume, "_blank");
  };

  return (
    <section className="jsp-card">
      <div className="jsp-card-head">
        <div className="jsp-card-head-left">
          <div className="jsp-card-icon">
            <BsFilePdf />
          </div>
          <div>
            <h3 className="jsp-card-title">Resume</h3>
            <p className="jsp-card-desc">PDF only · keep it up to date</p>
          </div>
        </div>
        <button
          type="button"
          className="jsp-btn jsp-btn-secondary"
          onClick={openFileInput}
        >
          <FaCloudUploadAlt size={15} />
          {userData?.resume ? "Replace" : "Upload"}
        </button>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept="application/pdf"
          onChange={handleFileChange}
        />
      </div>

      <div className="jsp-card-body">
        {userData?.resume ? (
          <div className="jsp-resume">
            <div className="jsp-resume-icon">
              <BsFilePdf />
            </div>
            <div className="jsp-resume-info">
              <div className="jsp-resume-name" title={filePath}>
                {filePath || "Resume.pdf"}
              </div>
              <div className="jsp-resume-actions">
                <button type="button" className="jsp-chip-btn" onClick={handleView}>
                  <FaRegEye /> View
                </button>
                <button type="button" className="jsp-chip-btn" onClick={handleDownload}>
                  <TfiDownload /> Download
                </button>
                <button type="button" className="jsp-chip-btn" onClick={openFileInput}>
                  <TbReplaceFilled /> Replace
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="jsp-empty">
            <strong>No resume uploaded</strong>
            Upload a PDF so employers can review your profile.
          </div>
        )}

        {resume && (
          <div className="jsp-upload-pending" style={{ marginTop: "0.9rem" }}>
            <span>{resume.name}</span>
            <button
              type="button"
              className="jsp-btn jsp-btn-primary"
              onClick={handleResumeUpload}
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Upload Resume"}
            </button>
            <button
              type="button"
              className="jsp-btn jsp-btn-ghost"
              onClick={() => setResume(null)}
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Resume;
